<template>
  <div class="auth">
    <div id="auth-content">
      <img src="/aceapp-logo.png" alt="Logo ACEAPP" class="p2" />
      <RouterView />
      <!-- <img src="/impulsado-por.png" alt="Klinicos Pie" class="p2" /> -->
    </div>
  </div>
</template>

<route lang="yaml">
  meta:
    title: PageTitle
</route>

<style scoped>
.auth {
  background-image: url(../../public/fondo.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  display: grid;
}
.p2 {
  padding-top: 2%;
  padding-bottom: 2%;
}
.responsive-image {
  width: 20%;
}
#auth-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 3%;
  min-height: 100vh;
}
h2 {
  color: #244125;
}
footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  background-image: none;
}
@media (max-width: 810px) {
  .responsive-image {
    width: 50%;
  }
}
</style>
